import React from 'react';
import { ICard } from '../../../@types/card';
import {
  StyleCardSubDepartment,
  StyleCardSubDescription,
  StyleCardSubTitleLine,
  StyleCardTitleLine,
  StyledContainer,
  TitleContent,
} from './styled.card';
import { Headline4 } from '../../../common/typography';
import { convertToTitleCaseAndCapitalizeFirst } from '../../../../utils/common';

export function Card ({
  title,
  description,
  department,
  client,
  onClick,
}: ICard) {
  return (
    <StyledContainer onClick={onClick} backgroundColor={client}>
      <StyleCardTitleLine>
        <TitleContent>
          <Headline4 ellipsis={true}>{title}</Headline4>
        </TitleContent>
        <Headline4>{convertToTitleCaseAndCapitalizeFirst(client)}</Headline4>
      </StyleCardTitleLine>
      <StyleCardSubTitleLine>
        <StyleCardSubDescription>{description}</StyleCardSubDescription>
        <StyleCardSubDepartment>{department}</StyleCardSubDepartment>
      </StyleCardSubTitleLine>
    </StyledContainer>
  );
}
